import React from 'react'
import { Link } from 'react-router-dom'
import dateHelper from '../../util/dateFormatter'
import { Translation } from 'react-i18next'
import i18n from '../../languages/lang.js'

const GroupList = props => {
    if (!props.data) {
        return (
            <Translation>
                {
                    (t) => (
                        <div id={'loading'}>{t('system.loading')}</div>
                    )
                }
            </Translation>
        )
    }

    if (props.data.length === 0) {
        return null
    }

    return (
        <ul id='group-list'>
            {props.data.map(item => {
                return (
                    <li>
                        <Link to={`/groups/${item.key}`}>{item.name} - {item.group_users ? item.group_users.length : 0} users</Link>
                    </li>
                )
            })}
            <li>
                <span>everyone</span>
            </li>
        </ul>
    )
}

export default GroupList
